/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateTimecardNoteRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {UpdateTimecardNoteResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const updateTimecardNote = (request: UpdateTimecardNoteRequest, options?: CashRequestOptions) => post<UpdateTimecardNoteRequest, UpdateTimecardNoteResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/UpdateTimecardNote", request, {...options, rejectOnError: true })